export default {
  props: {
    isMobile: Boolean,
    // { src, alt }
    picObj: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      scrollHeight: 0,
      // 图片外层容器高度是宽度的2.16倍， scrollHeight 是图片高度 减去 容器的高度
      imageHeight: 0,
      // 图片的高度
      currentTop: 0,
      // 当前的图片的定位
      timer: null,
      // 定时器
      director: 0 // 0: 向下滚动，1：向上滚动
    };
  },

  computed: {
    transitionStyle() {
      return {
        top: this.currentTop + "px"
      };
    }
  },
  watch: {
    imageHeight(val) {
      if (val > 20) {
        // 默认会为1，> 20作为判断真实渲染出的状态
        this.$nextTick(() => {
          this.currentTop = 0;
          this.director = 0;
          let parentTarget = this.imgElem.parentNode;
          if (parentTarget) {
            let parentReact = parentTarget.getBoundingClientRect();
            // 获取可滚动的区域高度
            this.scrollHeight = this.imageHeight - parentReact.height;
          }
        });
      }
    }
  },
  methods: {
    handleLoad(event) {
      if (this.isMobile) return;
      event = event || window.event;
      let target = event.target || event.srcElement;
      if (!this.imgElem) {
        this.imgElem = target;
      }
      let react = target.getBoundingClientRect();
      this.imageHeight = react.height;
    },
    stopTransition() {
      if (this.isMobile) return;
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    },
    restartTrasition() {
      if (this.isMobile) return;
      this.startTransition();
    },
    handleScroll() {
      if (!this.director) {
        this.currentTop -= 1;
        if (this.currentTop <= -this.scrollHeight) {
          this.currentTop = -this.scrollHeight;
          this.director = 1;
        }
      } else {
        this.currentTop += 1;
        if (this.currentTop >= 0) {
          this.currentTop = 0;
          this.director = 0;
        }
      }
    },
    startTransition() {
      // 当可滚动区域<=30 时，区域太小，就不进行滚动了
      if (!this.timer && this.scrollHeight > 30) {
        this.handleScroll();
        this.timer = window.setInterval(this.handleScroll, 30);
      }
    }
  },
  beforeUnmount() {
    if (this.isMobile) return;
    if (this.timer) {
      window.clearInterval(this.timer);
      this.timer = null;
    }
  }
};